/**
 * LensInspectCTA.jsx — Contextual Lens entry point
 *
 * A minimal inline CTA for proof-critical surfaces.
 * Activates Lens V2 focused on the parent's annotation context.
 * "seeing before deciding" — distinct from chat semantics.
 */
import React from 'react';
import { Eye } from 'lucide-react';
import { useGranulloLensV2 } from '../lens-v2';

const EDITORIAL_RED = '#CD2200';

export function LensInspectCTA({ label = 'Inspect in Lens', annotation, size = 'sm' }) {
  const { toggleLens, inspectElement, isActive } = useGranulloLensV2();

  const handleClick = (e) => {
    e.stopPropagation();
    if (annotation) {
      // Create a temporary annotated element for inspection
      const temp = document.createElement('div');
      Object.entries(annotation).forEach(([k, v]) => {
        temp.setAttribute(`data-lens-${k}`, v);
      });
      temp.setAttribute('data-lens-annotation', 'true');
      document.body.appendChild(temp);
      inspectElement(temp);
      setTimeout(() => temp.remove(), 100);
    } else {
      toggleLens();
    }
  };

  if (size === 'xs') {
    return (
      <button
        onClick={handleClick}
        className="inline-flex items-center gap-1 text-[10px] font-mono opacity-50 hover:opacity-100 transition-opacity"
        style={{ color: EDITORIAL_RED }}
        data-testid="lens-inspect-cta"
      >
        <Eye size={9} />
        <span>{label}</span>
      </button>
    );
  }

  return (
    <button
      onClick={handleClick}
      className="inline-flex items-center gap-1.5 text-[11px] font-mono px-2 py-1 rounded-md transition-all hover:bg-[var(--g-surface-2)]"
      style={{ color: EDITORIAL_RED, border: `1px solid ${EDITORIAL_RED}20` }}
      data-testid="lens-inspect-cta"
    >
      <Eye size={11} />
      <span>{label}</span>
    </button>
  );
}

export default LensInspectCTA;
